import React, { useEffect, useId, useState } from "react";
import {
  Row,
  Col,
  Button,
  ConfigProvider,
  Image,
  Card,
  Radio,
  Modal,
  Form,
  Input,
  Carousel,
  Divider,
} from "antd";
import {
  LoadingOutlined,
  CloseOutlined,
  LeftOutlined,
  RightOutlined,
} from "@ant-design/icons";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setDataNewCL } from "../redux/features/notification/notificationSlice";
import { setLocalStorage, getLocalStorageNewCl } from "../utils";

import defaultImage from "../assets/images/png/general/img_thumb_default.png";

// for translate
import { useTranslation } from "react-i18next";
import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";

import {
  iconGeneralBackground,
  colorTextDesc,
  ColorPrimary,
  ColorSecondary,
  backgroundCard,
  colorTextTitleMobile,
} from "../config/constant/color/index";

const ModalNotifNewCL = () => {
  const { t, i18n } = useTranslation();
  const dataNewCL = useSelector((state) => state.notification.dataNewCL);
  const userId = useSelector((state) => state.notification.userId);
  const dispatch = useDispatch();
  const screens = useBreakpoint();
  const isScallingVersion =
    (window.innerWidth <= 991 && window.innerWidth >= 768) ||
    window.innerWidth === 581;
  const isMobileVersion = screens.xs;
  const viewMobile = isMobileVersion || isScallingVersion;

  const [isOpen, setIsOpen] = useState(false);

  const location = useLocation();

  const CLData = [
    {
      image: defaultImage,
      type: "program",
      title:
        "Journey Begins, Forward Your Experience Journey Begins, Forward Your Experience Journey Begins, Forward Your Experience",
      desc: "Program pembelajaran ini ditujukan kepada karyawan baru Intikom. Setelah, menyelesaikan program ini, karyawan mampu beradaptasi dan mengimplementasikan nilai serta budaya perusahaan secara efektif dalam aktivitas sehari-hari. Program pembelajaran ini ditujukan kepada karyawan baru Intikom. Setelah, menyelesaikan program ini, karyawan mampu beradaptasi dan mengimplementasikan nilai serta budaya perusahaan secara efektif dalam aktivitas sehari-hari. Program pembelajaran ini ditujukan kepada karyawan baru Intikom. Setelah, menyelesaikan program ini, karyawan mampu beradaptasi dan mengimplementasikan nilai serta budaya perusahaan secara efektif dalam aktivitas sehari-hari.",
    },
    {
      image: defaultImage,
      type: "module",
      title: "Journey Begins, Forward Your Experience",
      desc: "Program pembelajaran ini ditujukan kepada karyawan baru Intikom. Setelah, menyelesaikan program ini, karyawan mampu beradaptasi dan mengimplementasikan nilai serta budaya perusahaan secara efektif dalam aktivitas sehari-hari.",
    },
    {
      image: defaultImage,
      type: "course",
      title: "Journey Begins, Forward Your Experience",
      desc: "Program pembelajaran ini ditujukan kepada karyawan baru Intikom. Setelah, menyelesaikan program ini, karyawan mampu beradaptasi dan mengimplementasikan nilai serta budaya perusahaan secara efektif dalam aktivitas sehari-hari.",
    },
    {
      image: defaultImage,
      type: "program",
      title: "Journey Begins, Forward Your Experience",
      desc: "Program pembelajaran ini ditujukan kepada karyawan baru Intikom. Setelah, menyelesaikan program ini, karyawan mampu beradaptasi dan mengimplementasikan nilai serta budaya perusahaan secara efektif dalam aktivitas sehari-hari.",
    },
    {
      image: defaultImage,
      type: "course",
      title: "Journey Begins, Forward Your Experience",
      desc: "Program pembelajaran ini ditujukan kepada karyawan baru Intikom. Setelah, menyelesaikan program ini, karyawan mampu beradaptasi dan mengimplementasikan nilai serta budaya perusahaan secara efektif dalam aktivitas sehari-hari.",
    },
    {
      image: defaultImage,
      type: "module",
      title: "Journey Begins, Forward Your Experience",
      desc: "Program pembelajaran ini ditujukan kepada karyawan baru Intikom. Setelah, menyelesaikan program ini, karyawan mampu beradaptasi dan mengimplementasikan nilai serta budaya perusahaan secara efektif dalam aktivitas sehari-hari.",
    },
    {
      image: defaultImage,
      type: "course",
      title: "Journey Begins, Forward Your Experience",
      desc: "Program pembelajaran ini ditujukan kepada karyawan baru Intikom. Setelah, menyelesaikan program ini, karyawan mampu beradaptasi dan mengimplementasikan nilai serta budaya perusahaan secara efektif dalam aktivitas sehari-hari.",
    },
    {
      image: defaultImage,
      type: "module",
      title: "Journey Begins, Forward Your Experience",
      desc: "Program pembelajaran ini ditujukan kepada karyawan baru Intikom. Setelah, menyelesaikan program ini, karyawan mampu beradaptasi dan mengimplementasikan nilai serta budaya perusahaan secara efektif dalam aktivitas sehari-hari.",
    },
    {
      image: defaultImage,
      type: "course",
      title: "Journey Begins, Forward Your Experience",
      desc: "Program pembelajaran ini ditujukan kepada karyawan baru Intikom. Setelah, menyelesaikan program ini, karyawan mampu beradaptasi dan mengimplementasikan nilai serta budaya perusahaan secara efektif dalam aktivitas sehari-hari.",
    },
  ];

  const handleClose = () => {
    const getLS =
      Array.isArray(getLocalStorageNewCl("new_cl")) === true
        ? getLocalStorageNewCl("new_cl")
        : JSON.parse(getLocalStorageNewCl("new_cl"));

    getLS.push(parseInt(userId));

    // console.log(getLS);
    setLocalStorage("new_cl", JSON.stringify(getLS));

    dispatch(setDataNewCL([]));
  };

  const checkType = (item) => {
    if (item.journey_id !== undefined && item.journey_id !== null) {
      return t("feature.feature_cl.cl_notification.program");
    }
    if (item.course_id !== undefined && item.course_id !== null) {
      return t("feature.feature_cl.cl_notification.course");
    }
    if (item.module_id !== undefined && item.module_id !== null) {
      return t("feature.feature_cl.cl_notification.module");
    }
  };

  const checkTitle = (item) => {
    if (item.journey_id !== undefined && item.journey_id !== null) {
      return item.name;
    }
    if (item.course_id !== undefined && item.course_id !== null) {
      return item.name;
    }
    if (item.module_id !== undefined && item.module_id !== null) {
      return item.fullname;
    }
  };

  const checkDesc = (item) => {
    if (item.journey_id !== undefined && item.journey_id !== null) {
      return item.description;
    }
    if (item.course_id !== undefined && item.course_id !== null) {
      return item.description;
    }
    if (item.module_id !== undefined && item.module_id !== null) {
      return item.description;
    }
  };

  useEffect(() => {
    const url = location.pathname;
    const arrId = url.split("/");

    if (
      url.indexOf("/content-library") > -1 &&
      arrId.length === 2 &&
      userId !== null
    ) {
      // console.log('masuk')

      const new_cl_localstorage =
        Array.isArray(getLocalStorageNewCl("new_cl")) === true
          ? getLocalStorageNewCl("new_cl")
          : JSON.parse(getLocalStorageNewCl("new_cl"));

      if (
        dataNewCL.length > 0 &&
        new_cl_localstorage.indexOf(parseInt(userId)) === -1
      ) {
        setIsOpen(true);
      } else {
        setIsOpen(false);
      }
    }
  }, [location, dataNewCL, userId]);

  return (
    <ConfigProvider
      theme={{
        components: {
          Carousel: {
            dotActiveWidth: 12,
            dotHeight: 12,
            dotWidth: 12,
          },
        },
        token: {
          fontFamily: "Roboto",
          borderRadiusLG: viewMobile ? 12 : 16,
        },
      }}
    >
      <Modal
        className={
          viewMobile
            ? "modal-notif-content-library-mobile"
            : "modal-notif-content-library"
        }
        open={isOpen}
        maskClosable={false}
        closeIcon={
          <div
            style={{
              padding: "9px 10px",
              display: "flex",
              background: iconGeneralBackground,
              borderRadius: "50%",
              border: "none",
            }}
            id="btn-modal-close-notif-content-library"
          >
            <CloseOutlined style={{ color: colorTextDesc, fontSize: "14px" }} />
          </div>
        }
        width={
          isMobileVersion ? (isScallingVersion ? `${585 * 0.9}px` : "90%") : 560
        }
        onCancel={() => {
          setIsOpen(!isOpen);
          handleClose();
        }}
        transitionName="ant-fade"
        keyboard
        centered
        footer={false}
        title={
          <div
            style={{
              padding: viewMobile ? "18px" : "32px 32px 15px 32px",
              fontSize: viewMobile ? 16 : 22,
              fontWeight: viewMobile ? 500 : "bold",
              lineHeight: viewMobile ? "18px" : "normal",
              width: viewMobile ? "100%" : "auto",
            }}
          >
            {i18n.language === "en" ? (
              <>
                {viewMobile
                  ? t("feature.feature_cl.cl_notification.since_mobile")
                  : t("feature.feature_cl.cl_notification.since")}
                <br />
                {viewMobile
                  ? t("feature.feature_cl.cl_notification.here_are_mobile")
                  : t("feature.feature_cl.cl_notification.here_are")}{" "}
                <span style={{ color: ColorPrimary }}>
                  {viewMobile
                    ? t("feature.feature_cl.cl_notification.cl_updates_mobile")
                    : t("feature.feature_cl.cl_notification.cl_updates")}
                </span>
                {viewMobile ? "" : <span>!</span>}
              </>
            ) : (
              <>
                <span style={{ color: ColorPrimary }}>
                  {viewMobile
                    ? t("feature.feature_cl.cl_notification.since_mobile")
                    : t("feature.feature_cl.cl_notification.since")}
                </span>
                <br />
                {viewMobile
                  ? t("feature.feature_cl.cl_notification.here_are_mobile")
                  : t("feature.feature_cl.cl_notification.here_are")}{" "}
                {viewMobile
                  ? t("feature.feature_cl.cl_notification.cl_updates_mobile")
                  : t("feature.feature_cl.cl_notification.cl_updates")}
              </>
            )}
          </div>
        }
        style={{ borderRadius: viewMobile ? 12 : 16 }}
      >
        <div
          style={{
            padding: viewMobile ? "0 18px" : "0 32px 0 32px",
            overflowY: "auto",
            height: "auto",
            maxHeight: "calc(100vh - 211px)",
          }}
        >
          {dataNewCL.length > 0
            ? dataNewCL.map((item, index) => (
                <div
                  key={index}
                  className="new-cl-item"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    height: viewMobile ? 70 : "100%",
                  }}
                >
                  <div style={{ position: "relative" }}>
                    <Image
                      style={{ borderRadius: 8, objectFit: "cover" }}
                      width={viewMobile ? 97 : 130}
                      height={viewMobile ? 70 : 87}
                      preview={false}
                      src={item.thumbnail}
                      fallback={defaultImage}
                    />
                    {!viewMobile && (
                      <div>
                        <div
                          style={{
                            fontWeight: "bold",
                            fontSize: 10,
                            color: backgroundCard,
                            background: ColorPrimary,
                            position: "absolute",
                            left: 0,
                            top: 0,
                            padding: "4px 6px",
                            borderTopLeftRadius: "8px",
                            borderBottomRightRadius: "8px",
                          }}
                        >
                          {checkType(item)}
                        </div>
                      </div>
                    )}
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-start",
                      marginLeft: viewMobile ? 12 : 20,
                    }}
                  >
                    {viewMobile && (
                      <div
                        className="break-dots-first-line"
                        style={{
                          fontSize: 10,
                          fontWeight: 400,
                          marginBottom: 3,
                          lineHeight: "15px",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          color: ColorPrimary,
                          textTransform: "uppercase",
                        }}
                      >
                        {checkType(item)}
                      </div>
                    )}
                    <div
                      className="break-dots-first-line"
                      style={{
                        fontSize: viewMobile ? 14 : 16,
                        fontWeight: 500,
                        marginBottom: viewMobile ? 6 : 8,
                        lineHeight: viewMobile ? "15px" : "normal",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        color: viewMobile ? colorTextTitleMobile : "inherit",
                      }}
                    >
                      {checkTitle(item)}
                    </div>
                    <div
                      className={
                        viewMobile
                          ? "break-dots-second-line"
                          : "break-dots-third-line"
                      }
                      style={{
                        fontSize: viewMobile ? 12 : 14,
                        lineHeight: viewMobile ? "15px" : 1.3,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        color: colorTextDesc,
                        fontWeight: 400,
                      }}
                    >
                      {checkDesc(item)}
                    </div>
                  </div>
                </div>
              ))
            : null}
        </div>
      </Modal>
    </ConfigProvider>
  );
};

export default ModalNotifNewCL;
